import { LoadingText } from '../styles/MultiUsageStyles'

const Loading = () => {
  return (
    <LoadingText>
      Loading...
    </LoadingText>
  )
};


export default Loading;